import type { ReactNode } from 'react';
import { useState } from 'react';

import { FactsheetOverlayContainerContext } from './FactsheetOverlayContainerContextBase';

interface FactsheetOverlayContainerProviderProps {
  children: ReactNode;
}

/**
 * Lets a page (e.g. the catalog table) claim a DOM node for the factsheet
 * dialog to render into, so it overlays that container instead of the whole
 * viewport. Pages that never call `useFactsheetOverlayContainer().setContainer`
 * leave the dialog full-screen.
 */
export const FactsheetOverlayContainerProvider = ({
  children
}: FactsheetOverlayContainerProviderProps) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  return (
    <FactsheetOverlayContainerContext value={{ container, setContainer }}>
      {children}
    </FactsheetOverlayContainerContext>
  );
};
